export const removeAnchorElement = (str = '') => {
  if (typeof str !== 'string') return str;
  return str.replace(/<\/?a[^>]*>/g, '');
};
